"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m13.28 8.5.76.58.92-.23L13 14.8V8.29zm-4.25.36L11 14.8V8.29l-.28.21-.76.59z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M14.5 6.92 13 5.77V3.4c0-.26.22-.48.5-.48s.5.21.5.48V4h2v-.6C16 2.07 14.88 1 13.5 1S11 2.07 11 3.4v2.37L9.5 6.92 6 6.07l5.05 15.25c.15.45.55.68.95.68s.8-.23.95-.69L18 6.07zM13.28 8.5l.76.58.92-.23L13 14.8V8.29zm-3.32.59.76-.58.28-.22v6.51L9.03 8.86z"
}, "1")], 'UmbrellaTwoTone');